/**
 * Model to change user password.
 */
export class ChangePassword {
    // Model properties have been kept in lowercase as per the FormParams
    // accepted by rest server.
    currentpassword = '';
    newpassword = '';
}



// WEBPACK FOOTER //
// ./src/app/header/usersettings/changepassword/change-password.model.ts